import dayjs from "dayjs";
import { Interval } from "./Interval.tsx";

export function createTodayInterval(): Interval {
  const startDate = dayjs(new Date()).startOf("week");
  const endDate = dayjs(startDate).endOf("week");
  return new Interval(startDate, endDate);
}
